// src/components/AnalyzingModal/index.tsx
import { FC, useEffect, useState } from 'react';
import { Modal, Button } from 'antd';
import SvgIcon from '@/components/SvgIcon';
import useIsMobile from '@/hooks/useIsMobile';
import { formatTip } from '@/utils/formatTip';
import styles from './index.module.scss';

interface AnalyzingModalProps {
  open: boolean;
  title: string;
  tips: string[];
  // 主按钮配置
  primaryText: string;
  onPrimaryClick: () => void;
  // 次要按钮配置
  cancelText: string;
  onCancel: () => void;
}

const AnalyzingModal: FC<AnalyzingModalProps> = ({ open, title, tips, primaryText, onPrimaryClick, cancelText, onCancel }) => {
  const [currentTipIndex, setCurrentTipIndex] = useState(0);
  const isMobile = useIsMobile();

  // Tips rotation logic (every 5 seconds)
  useEffect(() => {
    if (!open || tips.length === 0) {
      setCurrentTipIndex(0);
      return;
    }
    const interval = setInterval(() => {
      setCurrentTipIndex((prev) => (prev + 1) % tips.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [open, tips.length]);

  return (
    <Modal open={open} footer={null} centered width={isMobile ? 'calc(100vw - 48px)' : 400} closable={false} maskClosable={false} className={styles.analyzingModal}>
      <div className={styles.content}>
        <div className={styles.icon}>
          <SvgIcon name="loading-track" size={72} className={styles.track} />
          <SvgIcon name="loading" size={72} className={styles.spinner} />
        </div>
        <div className={styles.text}>
          <h3 className={styles.title}>{title}</h3>
          <div className={styles.tip}>
            <p>{tips[currentTipIndex] ? formatTip(tips[currentTipIndex]) : ''}</p>
          </div>
        </div>
        <div className={styles.buttons}>
          <Button type="primary" className={styles.primaryBtn} onClick={onPrimaryClick}>
            {primaryText}
          </Button>
          <Button className="btn-secondary" onClick={onCancel}>
            {cancelText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AnalyzingModal;
